const styles = {
    menuContainer: {
        maxHeight: "220px",
    },
};

export default styles;
